import React, { useEffect, useState } from 'react';
import AdminHeader from '../Header/AdminHeader';
import AdminFooter from '../Footer/AdminFooter';
import AdminLeftMenu from '../Navbar/AdminLeftMenu';
import { Link, useParams } from 'react-router-dom';
import { userloginDetails } from '../Utils/AdminAuth';
import { HOST_URL, STAGE_URL } from '../Dashboard/api/Api';
import Axios from '../../axios/Axios';
import axios from 'axios';
import styles from './AiBot.module.css';

const AI_BOT_STATUS_API = `${STAGE_URL}/ai-bot-access/status`;
const AI_BOT_TOGGLE_API = `${STAGE_URL}/ai-bot-access`;

const AiBot = () => {
    const lStorage = userloginDetails();
    const adminUserId = lStorage?.user?.userId;
    const adminToken = lStorage?.token;
    const type = lStorage?.user?.isAdmin;
    const permissionsubadmin = lStorage?.permission?.per_value?.usermanagement?.children;
    const { id, userType } = useParams();

    const [email, setEmail] = useState('');
    const [enabled, setEnabled] = useState(false);
    const [toggling, setToggling] = useState(false);
    const [error, setError] = useState({
        errorStatus: false,
        bgColor: '',
        errorMessage: ''
    });

    useEffect(() => {
        getUserDetails();
        checkAiBotAccess();
    }, []);

    const getUserDetails = async () => {
        try {
            const response = await fetch(
                `${HOST_URL}/admin_user_list.php?user_id=${adminUserId}&method=retrieve&type=userdetails&ret_user_id=${id}&token=${adminToken}`
            );
            const result = await response.json();

            if (result.success) {
                setEmail(result.data[0].email);
            } else {
                setError({
                    errorStatus: true,
                    bgColor: 'alert alert-danger alert-dismissible',
                    errorMessage: result.message
                });
            }
        } catch (err) {
            setError({
                errorStatus: true,
                bgColor: 'alert alert-danger alert-dismissible',
                errorMessage: err.message
            });
        }
    };

    const checkAiBotAccess = async () => {
        try {
            const { data } = await axios.post(AI_BOT_STATUS_API, {
                adminUserId: adminUserId,
                adminToken: adminToken,
                userId: id,
            });

            if (data.success) {
                setEnabled(data.status === 1);
            }
        } catch (err) {
            setError({
                errorStatus: true,
                bgColor: 'alert alert-danger alert-dismissible',
                errorMessage: err.response?.data?.message || 'Unable to fetch AI Bot status'
            });
        }
    };

    const handleToggle = async (e) => {
        const newStatus = e.target.checked ? 1 : 0;
        setToggling(true);
        try {
            const { data } = await axios.post(AI_BOT_TOGGLE_API, {
                adminUserId: adminUserId,
                adminToken: adminToken,
                userId: id,
                status: newStatus,
            });

            if (data.success) {
                setEnabled(newStatus === 1);
                setError({
                    errorStatus: true,
                    bgColor: 'alert alert-success alert-dismissible',
                    errorMessage: data.message || 'AI Bot status updated successfully'
                });
            } else {
                setError({
                    errorStatus: true,
                    bgColor: 'alert alert-danger alert-dismissible',
                    errorMessage: data.message || 'Failed to update AI Bot status'
                });
            }
        } catch (err) {
            setError({
                errorStatus: true,
                bgColor: 'alert alert-danger alert-dismissible',
                errorMessage: err.response?.data?.message || 'Something went wrong while updating AI Bot status'
            });
        } finally {
            setToggling(false);
        }
    };

    return (
        <div>
            <div className="wrapper">
                <AdminLeftMenu />
                <div className="main">
                    <AdminHeader />
                    <main className="content">
                        <div className="container-fluid p-0">
                            <div className="row mb-2 mb-xl-3">
                                <div className="col-auto d-none d-sm-block">
                                    <h3>AI Bot <strong className='text-info'>{email}</strong></h3>
                                </div>
                            </div>
                            <div className="row">
                                <div className="card">
                                    <div className="card-header">
                                        <h5 className="card-title mb-0">
                                            <nav className="text-center" aria-label="breadcrumb">
                                                <ol className="breadcrumb bg-transparent p-0 mt-1 mb-0">
                                                    <Link to={`/admin/user-details/${id}/${userType}`}><li className="breadcrumb-item">User Details</li></Link>
                                                   {(type === "admin" || type === "emp" || type === "reseller" || (type === "subadmin" && permissionsubadmin.transactiondetails)) && <Link to={`/admin/user-transaction-details/${id}/${userType}`}><li className="breadcrumb-item">Transaction Details</li></Link>}
                                                    {(type === "admin" || type === "emp" || type === "reseller" || (type === "subadmin" && permissionsubadmin.addeditprice)) &&<Link to={`/admin/user-price-details/${id}/${userType}?channel=whatsapp`}><li className="breadcrumb-item">Add Price</li></Link>}
                                                     {(type === "admin" || (type === "subadmin" && permissionsubadmin.awssettings)) && ( <Link to={`/admin/aws-settings/${id}/${userType}?channel=whatsapp`}><li className="breadcrumb-item">AWS Settings</li></Link>
                                                        )}
                                                    {(type === "admin" || (type === "subadmin" && permissionsubadmin.billingmode)) && (
                                                        <Link to={`/admin/user-billing-mode/${id}/${userType}`} >
                                                            {" "} <li className="breadcrumb-item">{" "} Billing Mode{" "} </li>
                                                        </Link>
                                                    )}
                                                    {(type === "admin" || type === "emp" || type === "reseller" || (type === "subadmin" && permissionsubadmin.addeditcredit)) && <Link to={`/admin/user-add-price/${id}/${userType}`}><li className="breadcrumb-item">Add Credit</li></Link>}
                                                           { (type === "admin" || (type === "subadmin" && permissionsubadmin.entitybypass)) &&<Link to={`/admin/user-entity-pass/${id}/${userType}`}><li className="breadcrumb-item">Entity By Pass</li></Link>}
                                                            {(type === "admin" || (type === "subadmin" && permissionsubadmin.changecurrency)) &&<Link to={`/admin/change-currency/${id}/${userType}`}><li className="breadcrumb-item">Change Currency</li></Link>}
                                                            {(type === "admin" || (type === "subadmin" && permissionsubadmin.bulksmsroutesetting)) &&<Link to={`/admin/bulk-sms-route/${id}/${userType}`}><li className="breadcrumb-item">Bulk Sms Route Setting</li></Link>}
                                                    {(type === "admin" || (type === "subadmin" && permissionsubadmin.autoshorturl)) &&
                                                        <Link
                                                            to={`/admin/api-auto-short-url/${id}/${userType}`}
                                                        >
                                                            <li className="breadcrumb-item">
                                                                Auto Short URL
                                                            </li>
                                                        </Link>}
                                                         {(type === "admin" || (type === "subadmin" && permissionsubadmin.extrasettings)) &&
                                                        <Link
                                                            to={`/admin/extra-settings/${id}/${userType}`}
                                                        >
                                                            <li className="breadcrumb-item">
                                                                Extra Settings
                                                            </li>
                                                        </Link>}
                                                    {(type === "admin" || (type === "subadmin" && permissionsubadmin.mmlite)) &&
                                                        <Link
                                                            to={`/admin/mmlite/${id}/${userType}`}
                                                        >
                                                            <li className="breadcrumb-item">
                                                                MMLite
                                                            </li>
                                                        </Link>}
                                                    {(type === "admin" || (type === "subadmin" && permissionsubadmin.ai_bot)) &&
                                                        <Link
                                                            to={`/admin/ai-bot/${id}/${userType}`}
                                                        >
                                                            <li className="breadcrumb-item active">
                                                                AI Bot
                                                            </li>
                                                        </Link>}

                                                        {(type === "admin" || (type === "subadmin" && permissionsubadmin.edituserplan)) &&
                                                        <Link
                                                            to={`/admin/edit-user-plan/${id}/${userType}`}
                                                        >
                                                            <li className="breadcrumb-item">
                                                                Edit User Plan
                                                            </li>
                                                        </Link>}
                                                </ol>
                                            </nav>
                                        </h5>
                                    </div>
                                    <div className="card-body">
                                        {error.errorStatus && (
                                            <div className={error.bgColor} role="alert">
                                                <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                                    <span aria-hidden="true">×</span>
                                                </button>
                                                <div>{error.errorMessage}</div>
                                            </div>
                                        )}
                                        <div className="filter-option">
                                            <div className="row mt-3">
                                                <div className='col-12'>
                                                    <div className='row mt-3'>
                                                        <div className='col-6'>
                                                            <div className={styles.statusRow}>
                                                                <label className={styles.switch}>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={enabled}
                                                                        disabled={toggling}
                                                                        onChange={handleToggle}
                                                                    />
                                                                    <span className={styles.slider}></span>
                                                                </label>
                                                                <span className={styles.statusLabel}>
                                                                    Enable AI Bot {enabled ? "(Enabled)" : "(Disabled)"}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                    <AdminFooter />
                </div>
            </div>
        </div>
    );
};

export default AiBot;
